import React from "react";
import { Card } from "../UI";
import { usd, pct } from "./format";

const COLS = [
  ["live", "Codes"], ["scanned", "Scanned"], ["claimed", "Claimed"], ["claim_rate", "Claim %", pct],
  ["redeemed", "Redeemed"], ["redeem_rate", "Redeem %", pct], ["redeemed_value", "Value redeemed", usd], ["outstanding_value", "Outstanding", usd],
];

export const BreakdownTable = ({ title, rows, nameKey, subKey, testid, emptyText }) => (
  <Card className="!p-0 overflow-hidden" data-testid={testid}>
    <div className="px-5 py-3 border-b border-white/10 font-display font-bold text-sm">{title}</div>
    {(!rows || rows.length === 0) ? (
      <div className="px-5 py-4 text-xs text-slate-500">{emptyText}</div>
    ) : (
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-[10px] uppercase tracking-wider text-slate-500">
              <th className="text-left px-5 py-2 font-medium">Name</th>
              {COLS.map(([k, l]) => <th key={k} className="text-right px-3 py-2 font-medium whitespace-nowrap">{l}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r[nameKey] + i} className="border-t border-white/5 hover:bg-white/[0.03]" data-testid={`${testid}-row-${i}`}>
                <td className="px-5 py-2">
                  <div className="text-slate-200 font-medium">{r[nameKey] || "—"}</div>
                  {subKey && r[subKey] && <div className="text-[10px] text-slate-500">{r[subKey]}</div>}
                </td>
                {COLS.map(([k, , fmt]) => (
                  <td key={k} className={`text-right px-3 py-2 tabular-nums ${k === "redeemed_value" ? "text-amber-300 font-medium" : "text-slate-300"}`}>{fmt ? fmt(r[k]) : r[k] || 0}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </Card>
);
